import prettyChartNumber from 'ui-library/charting/util/prettyChartNumber';

/**
 * Format a coefficient and a variable into the standard expression format for charts.
 *
 * Formatting typically involves prettifying the coefficient and adding it to the front of the variable.
 *
 * Special cases:
 *   1. If the coefficient is 0, returns 0
 *   2. If the coefficient is 1 and variable exists, returns just the variable
 *   3. If the coefficient is -1 and variable exists, returns -variable
 */
export default function prettyExpression(coefficient: number, variable: string | null): string {
  const coefficientString = prettyChartNumber(coefficient);
  if (coefficient === 0) {
    return '0';
  } else if (variable == null) {
    return `${coefficientString}`;
  } else if (coefficient === 1) {
    return variable;
  } else if (coefficient === -1) {
    return `-${variable}`;
  } else {
    return `${coefficientString}${variable}`;
  }
}
